const DEFAULTS =   {
  categoriesUrl: window.location.host.includes('cablelabs.com') ? 'https://specification-api.cablelabs.com/categories' : ' https://dev-specification-api.cablelabs.com/categories',
  docTypesUrl: window.location.host.includes('cablelabs.com') ? 'https://specification-api.cablelabs.com/doctypes' : 'https://dev-specification-api.cablelabs.com/doctypes',
  categorySelector: '[data-specification-cat]',
  subCatSelector: '[data-specification-subcat]',
  doctypeSelector: '[data-specification-type]',
};

/**
 * Fills select dropdowns in the Specification Library Search form
 * with content from Alfresco.
 * @param  {HTMLElement} formEl  The form element. Used to find the select inputs.
 * @param  {object} options      The options for this class. See DEFAULTS above.
 */
export default class specsSearch {
  constructor(formEl, options = DEFAULTS) {
    this.options = {...DEFAULTS, ...options};
    this.categorySelect = formEl.querySelector(this.options.categorySelector);
    this.subCatSelect = formEl.querySelector(this.options.subCatSelector);
    this.subCatSelectOriginalHTML = this.subCatSelect.innerHTML;
    this.doctypeSelect = formEl.querySelector(this.options.doctypeSelector);
    this.fetchDropdownContent();
  }

  /**
   * fetches the categories and doctype informantion used ot fill the dropdowns
   * @return {void}
   */
  fetchDropdownContent() {
    this._fetchData(this.options.categoriesUrl)
      .then(cats => {
        this._fillSelect(this.categorySelect, cats);
        this.categorySelect.addEventListener('change',
          e => this._setSubcategorySelect(e.target.value, cats));
      })
      .catch(() => console.debug('Failed to fetch specifications categories. There is probably a warning message above.'));

    this._fetchData(this.options.docTypesUrl)
      .then(doctypes => this._fillSelect(this.doctypeSelect, doctypes))
      .catch(() => console.debug('Failed to fetch specifications doctypes. There is probably a warning message above.'));

  }

  /**
   * Fills the sub-category select dropdown based on the chosen category.
   * @param {[type]} catValue      [description]
   * @param {[type]} allCategories [description]
   */
  _setSubcategorySelect(chosenCatValue, allCategories) {
    const chosenCategory = allCategories.find(cat => cat.value === chosenCatValue);
    if (!chosenCategory) return;
    this.subCatSelect.innerHTML = this.subCatSelectOriginalHTML;
    this._fillSelect(this.subCatSelect, chosenCategory.subcats);
  }

  /**
   * Fills a <select> element with <option> elements, given an array of values.
   * @param  {HTMLElement} selectEl The <select> to fill
   * @param  {array} values   An array of values. Can be an array of strings,
   *                          or an array of objects with value and name properties
   * @return {void}
   */
  _fillSelect(selectEl, values) {
    let optionsHtml = selectEl.innerHTML;
    values.forEach(v => optionsHtml += this._createOption(v.value||v, v.name));
    selectEl.innerHTML = optionsHtml;
  }

  /**
   * Create an <option> element to be appended inside a <select>
   * @param  {string} value The value the option should have
   * @param  {name}   name  (optional) The display name of the option.
   *                        Defaults to the value if no name is provided.
   * @return {string}       The <option> markup as a string.
   */
  _createOption(value, name) {
    return `<option value="${value}">${name||value}</option>`;
  }

  /**
   * Gets data from the spec search url using Fetch API
   * @param  {string} url  The url to request from
   * @return {promise}     The promise of data.
   */
  _fetchData(url) {
    return fetch(url)
      .then(resp => resp.json())
      .catch(this._handleNetworkError);
  }

  _handleNetworkError() {
    if (window.location.host.includes('cablelabs.com')) {
      console.warn('[Specs Search] Specifications Search API not available.');
    } else {
      console.warn('[Specs Search] You need to be on the CableLabs VPN to access dev-specification-api.cablelabs.com.');
      // In local development mode,
      // this component makes requests to the dev-specification-api.cablelabs.com, which is only accessible over VPN.
      // In a production environment (prod, staging and development environments),
      // it will make requests to Spec Search's production URL.
    }
  }

}
